import React from 'react';

import { logger } from '../../lib/logger';
import { Choice } from '../../types/narrative';
import { ChoiceInput, ChoiceTextarea } from '../ChoiceInput';

const itemLogger = logger.child('[ChoiceItem]');

interface ChoiceItemProps {
  choice: Choice;
  index: number;
  onChoiceTextChange: (value: string) => void;
  onNpcResponseChange?: (value: string) => void;
  isReturnToAPlotNode: boolean;
  worldStateIndicator?: '(BETTER)' | '(WORSE)' | null;
}

export const ChoiceItem = React.memo(function ChoiceItem({
  choice,
  index,
  onChoiceTextChange,
  onNpcResponseChange,
  isReturnToAPlotNode,
  worldStateIndicator,
}: ChoiceItemProps) {
  itemLogger.debug('Rendered');

  return (
    <div className="space-y-2">
      <div className="flex items-start gap-2">
        <span className="text-gray-400 text-sm mt-2 w-4">{index + 1}.</span>
        <div className="flex-grow space-y-2">
          <div className="flex items-center gap-2">
            <ChoiceInput
              value={choice.text}
              onChange={onChoiceTextChange}
              placeholder={`Enter choice ${index + 1}...`}
              className="flex-grow bg-gradient-to-br from-[#1a223a] to-[#1e2749] border border-[#2a3756] rounded-lg p-3 text-white focus:outline-none focus:border-[#4f46e5] focus:shadow-[0_0_16px_rgba(79,70,229,0.25)] focus:scale-[1.01] hover:border-[#06b6d4] placeholder-gray-500 text-sm transition-all duration-300 shadow-[0_2px_8px_rgba(0,0,0,0.15)]"
              maxLength={200}
            />
            {isReturnToAPlotNode && worldStateIndicator && (
              <span
                className={`text-xs font-semibold px-2 py-1 rounded ${
                  worldStateIndicator === '(BETTER)'
                    ? 'text-[#10b981] bg-[#10b981]/20'
                    : 'text-[#ef4444] bg-[#ef4444]/20'
                }`}
              >
                {worldStateIndicator}
              </span>
            )}
          </div>
          {choice.npcResponse !== undefined && onNpcResponseChange && (
            <div className="ml-4">
              <label className="text-[#a78bfa] text-xs mb-1 block">
                NPC Response (shown before next node):
              </label>
              <ChoiceTextarea
                value={choice.npcResponse || ''}
                onChange={onNpcResponseChange}
                placeholder="NPC reaction to this choice..."
                className="w-full bg-gradient-to-br from-[#1a223a] to-[#1e2749] border border-[#2a3756] rounded-lg p-3 text-white focus:outline-none focus:border-[#4f46e5] focus:shadow-[0_0_16px_rgba(79,70,229,0.25)] focus:scale-[1.01] hover:border-[#06b6d4] placeholder-gray-500 text-sm min-h-[60px] transition-all duration-300 shadow-[0_2px_8px_rgba(0,0,0,0.15)] resize-none"
                maxLength={300}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
});
